import React from "react";
import { Skeleton } from "@mui/material";

export default ({ variant = "text", width = "", height = "" }) => {
	return <Skeleton variant={variant} width={width} height={height} />;
};
